// Label above a filter control, shared by the filter popovers of Tasks and Prospects.
export function FilterField({ label, children }) {
  return (
    <div className="space-y-1.5">
      <div className="text-xs font-medium text-slate-500">{label}</div>
      {children}
    </div>
  );
}
